package twist.mena.sports.admin.screens

import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import twist.mena.sports.admin.api.AdminApiClient
import twist.mena.sports.admin.components.Column
import twist.mena.sports.admin.components.DataTable
import twist.mena.sports.admin.components.SearchBar
import twist.mena.sports.admin.state.UiState
import twist.mena.sports.admin.theme.*
import twist.mena.sports.shared.dto.admin.AdminLeagueResponse
import twist.mena.sports.shared.dto.admin.OffsetPage

@Composable
fun LeaguesScreen(apiClient: AdminApiClient) {
    val colors = AppTheme.colors
    var state by remember { mutableStateOf<UiState<OffsetPage<AdminLeagueResponse>>>(UiState.Loading) }
    var search by remember { mutableStateOf("") }
    var offset by remember { mutableStateOf(0) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(search, offset) {
        state = UiState.Loading
        scope.launch {
            try {
                val page = apiClient.getLeagues(search.ifBlank { null }, offset)
                state = UiState.Success(page)
            } catch (e: Exception) {
                state = UiState.Error("Failed to load leagues")
            }
        }
    }

    SearchBar(placeholderText = "Search leagues...") { query ->
        search = query
        offset = 0
    }

    when (val s = state) {
        is UiState.Loading -> P({ style { color(Color(colors.textMuted)) } }) { Text("Loading...") }
        is UiState.Error -> P({ style { color(Color(colors.danger)) } }) { Text(s.message) }
        is UiState.Success -> {
            val page = s.data
            val columns = listOf(
                Column<AdminLeagueResponse>("Arabic Name") { league ->
                    Text(league.displayNameAr ?: league.displayNameEn)
                },
                Column("English Name") { league -> Text(league.displayNameEn) },
                Column("Type") { league -> Text(league.type) },
                Column("Vendor ID") { league ->
                    Span({ style { fontFamily("monospace"); fontSize(Typography.sm) } }) {
                        Text(league.vendorLeagueId)
                    }
                },
                Column("Last Synced") { league ->
                    Span({ style { fontSize(Typography.sm); color(Color(colors.textMuted)) } }) {
                        Text(league.syncedAtUtc.take(10))
                    }
                }
            )

            DataTable(
                columns = columns,
                rows = page.data,
                total = page.total,
                offset = page.offset,
                limit = page.limit,
                onPageChange = { newOffset -> offset = newOffset }
            )
        }
    }
}
